// src/mixins/notifications.mixin.js

import ToastContent from '@/components/legacy/shared/misc/Toast.vue'

export default {
    data() {
      return {
        isStatusNotificationLoading: false,
        isAlarmNotificationLoading: false,
        failedConnectionWithAxios: false,
        notificationsInterval: null,
      };
    },
    methods: {
      startInterval() {
        this.notificationsInterval = setInterval(this.reloadNotifications, 1500);
      },
      stopInterval() {
        if (this.notificationsInterval) clearInterval(this.notificationsInterval);
        this.notificationsInterval = null;
      },
      showToast(message) {
        if (!this.$enableToasts.getIsToastsEnabled()) {
          this.$toast.clear(); return;
        }
        const router = this.$router;
        const waitNextTick = async () => await this.$nextTick();
  
        const toast = message.isAlarm
          ? (message.value == "Normal" ? this.$toast.success : this.$toast.error)
          : (message.value == "Online" ? this.$toast.success : this.$toast.warning);
  
        const toastId = toast(
          {
            component: ToastContent,
            props: { message, i18n: this.$i18n },
            listeners: {
              redirect: async (route) => {
                router.push('/dashboard').catch(() => {});
                await waitNextTick();
                router.push(route);
              },
              close: () => this.$toast.dismiss(toastId),
            },
          },
          {
            position: "bottom-left",
            timeout: 5000,
            closeOnClick: false,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: false,
            draggablePercent: 0.6,
            hideProgressBar: false,
            closeButton: false,
            showCloseButtonOnHover: true,
            icon: false,
            rtl: false,
          }
        );
      },
      async reloadNotifications() {
        const userId = this.$session.get("logged_id");
  
        if (!this.isStatusNotificationLoading) {
          this.isStatusNotificationLoading = true;
          this.statusService.getLatestByUserId(userId).then(res => {
            // eslint-disable-next-line
            Status.SetStatusResponse(res);
            this.isStatusNotificationLoading = false;
          });
        }
  
        if (!this.isAlarmNotificationLoading) {
          this.isAlarmNotificationLoading = true;
          this.alarmDataService.getLatestByUserId(userId).then(alarms => {
            for (let alarm of alarms) {
              let topic = `alarm/${alarm.id}`;
              // eslint-disable-next-line
              Alarm.UpdateAlarm(topic, alarm);
            }
            this.isAlarmNotificationLoading = false;
          });
        }
        this.loadAlarmNotifications();
        this.loadStatusNotifications();
      },
      loadStatusNotifications() {
        // eslint-disable-next-line
        const statusMap = Status.GetStatusMap();
        statusMap.forEach((item) => {
          const topic = item.name;
          const value = item.value;
          if (!value.show || !value.statusNotification) return;
          // eslint-disable-next-line
          Status.SetStatusShow(topic);
          const message = {
            isAlarm: false,
            value: value.value == '0' ? "Offline" : "Online",
            target: `${value.name} (${topic.split("/")[0]})`,
            time: value.datetime.split(" ")[1],
          };
          this.showToast(message);
        });
      },
      loadAlarmNotifications() {
        // eslint-disable-next-line
        const alarmMap = Alarm.GetAlarmMap();
        alarmMap.forEach(item => {

          const { name, value } = item;
          if (!value.show) return;
          // eslint-disable-next-line
          Alarm.SetAlarmShow(name);
          console.log(value)
  
          const list = ["Normal", "Pre-Ativo", "Ativo"];
          const alarmType = list[parseInt(value.value)];
          const affectedDashboards = [];
          const affectedLayers = [];
  
          this.alarmService.search(value.id).then(res => {
            const message = {
              isAlarm: true,
              value: alarmType,
              id: parseInt(value.id),
              idDb: value.idDb,
              target: value.name,
              time: value.datetime.split(" ")[1],
              dashboards: affectedDashboards,
              layers: affectedLayers,
              showVideo: res.showVideo,
            };
            this.showToast(message);
          });
        });
      },
    },
    beforeDestroy() { this.stopInterval(); },
  };
  